import { Form } from 'factorial-form'

class ClockPicture extends Form {
  constructor(values: {}) {
    super(values, {
      employee_name: 'string',
      clocked_date: 'string',
      clock_time: 'string',
      status: 'string',
    })
  }
}

export default ClockPicture
